module.exports = __webpack_public_path__ + "img/lookup.b36c58e6.png";